import store from '@/shared/store'
export const validaAutenticacao = async () => {
    const autenticacao = await store._modules.root.context.dispatch('usuarios/carregaUsuarioLogado')
    return !(autenticacao && autenticacao.status === 'error')
};